import { render, staticRenderFns } from "./DmsView.vue?vue&type=template&id=4fa2685c&scoped=true"
import script from "./DmsView.vue?vue&type=script&lang=js"
export * from "./DmsView.vue?vue&type=script&lang=js"
import style0 from "./DmsView.vue?vue&type=style&index=0&id=4fa2685c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2685c",
  null
  
)

export default component.exports